import React from "react";
import "./footer.scss";
import { HashLink } from "react-router-hash-link";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { hash } = useLocation();
  const isActive = (iHash) => hash === iHash;
  return (
    <>
      <section className="mainfooter">
        <div className="custom-container">
          <p>©2026 Queen Wars. All rights reserved.</p>
        </div>
      </section>
   
      
    </>
  );
};

export default Footer;
